<template>
  <div class="page">
    <div v-for="(item, index) in columnInfo" :model="pageData" :key="index">
      <div>
        <Spe v-if="item.id == 1012002" @change="getMFInfo" :item="item"> </Spe>
        <div v-else>
          <el-form-item :required="item.required" v-if="item.uiType == 1">
            <span slot="label">
              <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <el-input :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
              @input="upInput(item.index)" @blur='emitInput(item.index)'></el-input>
          </el-form-item>
        </div>
      </div>

      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 2">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input type="textarea" :style="input_width" :disabled="!item.editable" v-model="pageData[item.index]"
            @input="upInput(item.index)" @blur='emitInput(item.index)'></el-input>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="[3, 4].includes(item.uiType)" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <Prolist :style="input_width" :data="uplistData(item)" @change="upList"> </Prolist>

        </el-form-item>
      </div>


      <div>
        <el-form-item v-if="item.uiType == 6" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-date-picker :style="input_width" v-model="pageData[item.index]" type="datetime"
            @change="upDateTime(item.index)" :placeholder="$t('message.placeholder.pickDate')">
          </el-date-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 7">
          <!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
            @input="upInput(item.index)" @blur='emitInput(item.index)'></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 10">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
          <el-input :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
            @input="upInput(item.index)" @blur='upCurrency(item.index)'>
            <el-select v-model="currencyIdList[item.index]" slot="append"
              :placeholder="$t('message.placeholder.select')" @change="upCurrencyId(item.index)"
              :disabled="!item.editable" style="width:88px">
              <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie"
                :key="items.id"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
      </div>
    </div>



  </div>
</template>

<script>
import Spe from './special.vue'
import searchListValues from "@/components/searchListValues.vue"
import Prolist from './list.vue'
export default {
  data() {
    return {
      listInfo: {},
      searchAddList: false, //是否显示search list window
      mData: '',
      pageInfo: {},
      columnInfo: [],
      pageData: [],
      input_width: {
        width: "65%",
      },
      cascadeList: [],
      cascadeMultiList: [],
      currencyIdList: [],
      multi: { multiple: true, checkStrictly: true },
      typeList: [1000002, 1004003, 1011002, 1012005, 1051009, 4010002, 5010002, 5020003],
      nameList: [1000001, 1004001, 1011001, 1012001, 4010001, 5010001, 5020001],
      resetNum: "",
      nameId: "",
      subData: {},
      isReq: true,
      // uplistData :{}
    };
  },
  components: {
    Spe,
    searchListValues,
    Prolist
  },
  props: ["page", "pageId", "reset", "modifiedValue"],
  methods: {

    uplistData(item) {
      return { item, val: this.pageData[item.index] }
    },


    upList(e) {
      console.log(e);
      const { val, item } = e;
      // let m = this.columnInfo.find(i =>i.index == item.index).id;
      // this.$set(this.subData,m,val);
      this.pageData[item.index] = val;
      this.subData[item.id] = val;
      this.upData()
      this.$forceUpdate();

    },
    // addToListDisplay(selectedListValue){

    //   if(this.listInfo.uiType==3){
    //     console.log(this.listInfo);
    //     this.searchAddList = false;
    //     // this.pageData[selectedListValue.listIndex] = selectedListValue.listId;
    //     this.pageData[this.listInfo.index]=selectedListValue.listId;
    //     this.subData[this.listInfo.id] = selectedListValue.listId;
    //     this.upData();
    //     // this.upSimpleList(selectedListValue.listIndex);
    //   };
    //   // console.log(this.pageData[selectedListValue.listIndex]);
    // },
    openSearchListWindow(item) {
      this.searchAddList = true;
      this.listInfo = item;

    },
    updateListEntries(e) {

      this.columnInfo.map(i => {
        if (i.listId == this.listInfo.listId) {
          i.listEntrie = e.map(i => ({ id: i.listId + "_" + i.entryId, name: i.entryValue }));
        }
      })
    },

    getColumn() {
      console.log(this.page);
      let column = this.getNewData(this.page.object.columnInfo).filter(i => i.required || i.defaultValue !== "");
      // column = column.filter(i =>i.required)
      console.log(column);
      column.map((i, e) => {
        i.index = e;
        if (this.typeList.includes(i.id)) {
          i.editable = false;
          i.listType = 1;
          i.listEntrie = [{ id: this.pageId.id, name: this.pageId.name }];
          this.pageData[i.index] = this.pageId.id;
          this.subData[i.id] = this.pageData[i.index];
        };
        if (this.nameList.includes(i.id)) {
          if (this.page.object.columnInfo.autoNumber == -1) {
            i.editable = true;
            this.resetNum = "";
          } else {
            this.pageData[i.index] = this.$t("message.title.autoNumber"); //subclassId;
            this.subData[i.id] = this.pageData[i.index]
            this.resetNum = -1;
            i.editable = false;
          }
        };
        if (i.uiType == 10) {
          console.log(i);
          // this.pageData[i.index] = arr[e].realVal;
          this.currencyIdList[i.index] = i.listEntrie || [];
          // i.val = arr[e];
        }
      });
      this.getDefaultValues(column);
      // this.$emit("update:change", this.pageData);

      this.columnInfo = column.filter(i => i.required);
      console.log(column);
      this.upData();
    },
    getDefaultValues(data) {

      // if (i.defaultValue) {
      //     this.pageData[i.index] = i.defaultValue;
      //     console.log(i.defaultValue,i.index);
      //   }
      const arr = data.filter(i => !!i.defaultValue);
      arr.map(i => {
        console.log(i);
        // const e = this.columnInfo.find(item =>item.index == i.index).id;
        const e = i.id;
        this.subData[e] = this.pageData[i.index];
        if (i.uiType == 3 && i.listType == 2) {
          let val_ = i.defaultValue.split(",");
          val_ = val_[0].split(";");
          let searchVal_ = val_[val_.length - 1];
          this.subData[i.id] = searchVal_;
          this.pageData[i.index] = this.getParentIdListByPid(i.listEntrie, searchVal_);
          // this.subData[i.id] = this.pageData[i.index]
        }
        else if (i.uiType == 4) {
          if (i.listType == 2) {
            let Val_ = i.defaultValue.split(";");
            let searchVal_ = [];
            Val_.map(i => {
              let val = i.split(",");
              searchVal_.push(val[val.length - 1]);
            });
            this.subData[i.id] = searchVal_.join(";");
            this.pageData[i.index] = searchVal_.map((j) => { return this.getParentIdListByPid(i.listEntrie, j) });

          };
          if (i.listType == 1 || !i.listType) {
            this.subData[i.id] = i.defaultValue;
            this.pageData[i.index] = i.defaultValue.split(";");
          };
        }
        else if (i.uiType == 10) {
          this.subData[i.id] = parseFloat(i.defaultValue).toFixed(2);
          this.pageData[i.index] = parseFloat(i.defaultValue).toFixed(2);
        }
        else {
          this.subData[i.id] = i.defaultValue;
          this.pageData[i.index] = i.defaultValue;
        }
        //console.log(this.columnInfo);
        //const e = this.columnInfo.find(item =>item.index == i.index).id;
        // this.subData[e] = this.pageData[i.index];
        //console.log(this.subData);
      })
    },

    upInput(i) {
      this.$forceUpdate();
      if (this.columnInfo.find(item => item.index == i).uiType == 10) {
        let n = this.pageData[i];
        this.pageData[i] = n.replace(/[^0-9.]/g, '');
        if (!Number(n)) {
          this.pageData[i] = '';
        }
      }
    },
    emitInput(i) {
      let n = this.pageData[i];
      let m = this.columnInfo.find(item => item.index == i).id;
      this.subData[m] = n.trim();
      this.upData()
    },
    upCurrency(i) {
      let n = parseFloat(this.pageData[i]).toFixed(2);
      n = isNaN(n) ? '' : n
      const m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.pageData, i, n)
      this.subData[m] = n;
      if (!this.currencyIdList[i]) {
        const currencyId = m + '_01';
        const defaultCurrency = this.columnInfo.find(item => item.index == i).listEntrie[0].id;
        // this.currencyIdList[i] = defaultCurrency;
        this.subData[currencyId] = defaultCurrency;
      }
      this.upData()
    },
    upCurrencyId(i) {
      const currencyId = this.columnInfo.find(item => item.index == i).id + '_01';
      this.subData[currencyId] = this.currencyIdList[i];
      this.$forceUpdate();
      this.upData();
    },
    upCascadeList(i) {
      this.$forceUpdate()
      console.log(i);
      let n = this.pageData[i];
      console.log(n);
      if (n == undefined) {
        return
      }
      let m = this.columnInfo.find(item => item.index == i).id;
      // console.log(m);
      this.subData[m] = !!n && JSON.stringify(n) != '[]' ? n[n.length - 1] : ''
      // console.log(this.subData);
      this.upData()
    },

    upSimpleList(i) {
      this.$forceUpdate()
      let n = this.pageData[i];
      let m = this.columnInfo.find(item => item.index == i).id;
      //// console.log(n);
      this.subData[m] = n;
      this.upData()
    },
    upMultiList(i) {
      this.$forceUpdate()
      let n = this.pageData[i]
      let m = this.columnInfo.find(item => item.index == i).id;
      this.subData[m] = n.join(';')
      this.upData()
    },
    upCascadeMultiList(i) {
      let n = this.deepCopy(this.pageData[i]);
      let m = this.columnInfo.find(item => item.index == i).id;
      this.subData[m] = n.length ? n.map(this.arrLast).join(';') : '';
      this.upData()
    },
    upDateTime(i) {
      //this.subData[i] = this.pageData[i];
      let m = this.columnInfo.find(item => item.index == i).id;
      this.subData[m] = this.pageData[i]
      this.upData();
    },
    upData() {
      console.log(this.subData);
      this.isReq = !this.columnInfo.find(i => !this.subData[i.id] || this.subData[i.id] == '');

      console.log(this.isReq);
      // console.log(this.subData);
      this.$emit("update:change", this.subData);
      this.$emit('update:checkReq', this.isReq)
    },
    arrLast(n) {
      n = n.length > 0 ? n[n.length - 1] : ''
      return n
    },

    getMFInfo(e) {
      // console.log(e.label);
      // console.log('!!!!!!!!!!!!!!!');
      if (e) {
        this.subData['1012002'] = e.label;
        this.upData();
        this.$emit('MFValue', e.value)
      }
    }
  },
  created() {
    // console.log(this.pageId);
    this.getColumn();
    // console.log(this.columnInfo);
  },
  watch: {
    reset() {
      this.pageData = [];
      this.getColumn();
    },
    // getMFInfo(){
    //   console.log('!!!!!!!!');
    // }
    modifiedValue() {
      //原本modifiedValue中只有一条数据，但现在modifiedValue中有多条数据所以要循环展开
      console.log(this.subData);
      this.columnInfo.map(i => {
        for (let index = 0; index < this.modifiedValue.length; index++) {
          if (i.id == this.modifiedValue[index].id) {
            if (i.uiType == 1 || i.uiType == 2) {
              if (i.editable == true) {
                this.pageData[i.index] = this.modifiedValue[index].value;
                this.subData[this.modifiedValue[index].id] = this.pageData[i.index];
                this.upInput(i.index);
              }
            }
            if (i.uiType == 3 || i.uiType == 4) {
              if (i.editable == true) {
                let listEntrie = i.listEntrie;
                listEntrie.map(listItem => {
                  if (listItem.name == this.modifiedValue[index].value) {
                    this.pageData[i.index] = listItem.id;
                    this.subData[this.modifiedValue[index].id] = this.pageData[i.index];
                    this.upInput(i.index);
                  }
                });
              }
            }
          }
        }
      })
      this.upData();
      console.log(this.subData);
      console.log(this.page);
      console.log(this.modifiedValue);
      console.log(this.pageData);
      console.log(this.columnInfo);
    },
  },

};
</script>

<style scoped>
.page {
  margin-top: 58px;
}
</style>
